import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

// import { utcToLocal } from './../../../utils/timeConverter';
import SingleEventRecord from '../SingleEventRecord';
import EditEventRecord from '../EditEventRecord';

const useStyles = makeStyles((theme) => ({
  recordsListContainer: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  table: {
    minWidth: 650
  },
  boldText: {
    fontWeight: 800
  }
}));

const RecordsList = (props) => {
  const classes = useStyles();
  const {
    records,
    handleDeleteEventRecordClick,
    enableEditEventRecord,
    isEditRecordEnabled,
    recordBeingEdited,
    handleEditEventRecordInputChange,
    handleSaveEventRecordClick,
    userId,
    handleRemoveAttachment,
    allAttachments
  } = props;

  return (
    <TableContainer component={Paper} className={classes.recordsListContainer}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className={classes.boldText}>Date</TableCell>
            <TableCell className={classes.boldText}>Next Event</TableCell>
            <TableCell className={classes.boldText}>Notes</TableCell>
            <TableCell className={classes.boldText} align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map((record) => {
            const isExpired = moment().isAfter(record.nextEventDate);

            const isEditMode =
              isEditRecordEnabled && record.id === recordBeingEdited.id;

            return (
              <TableRow key={record.id}>
                {isEditMode ? (
                  <EditEventRecord
                    record={recordBeingEdited}
                    handleEditEventRecordInputChange={
                      handleEditEventRecordInputChange
                    }
                    enableEditEventRecord={enableEditEventRecord}
                    handleSaveEventRecordClick={handleSaveEventRecordClick}
                    allAttachments={allAttachments}
                    handleRemoveAttachment={handleRemoveAttachment}
                  />
                ) : (
                  <SingleEventRecord
                    record={record}
                    userId={userId}
                    isExpired={isExpired}
                    enableEditEventRecord={enableEditEventRecord}
                    handleDeleteEventRecordClick={handleDeleteEventRecordClick}
                  />
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RecordsList;
